import React from 'react';
import './leaderboard.css';
import rankOne from '../../../assets/leaderboard/rank-one.svg';
import rankTwo from '../../../assets/leaderboard/rank-two.svg';
import rankThree from '../../../assets/leaderboard/rank-three.svg';
import coinsIcon from '../../../assets/leaderboard/coins-icon.svg';


const LeaderboardCard = ({ data }) => {
    // Sort data by combined score descending
    const sorted = [...data].sort((a, b) => b.combined - a.combined).slice(0, 3);
  const getInitials = (name) => {

        return name ? name.charAt(0).toUpperCase() : "U";
    };
    
     const avatarFallbackStyle = {
        // width: "40px",
        height: "100%",
        borderRadius: "50%",
        backgroundColor: "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: "600",
        color: "#6b7280",
    };
    // Map ranks to frames
    const frameMap = {
        1: rankOne,
        2: rankTwo,
        3: rankThree,
    };

    // Map ranks to medal class names
    const medalMap = {
        1: 'gold',
        2: 'silver',
        3: 'bronze',
    };

    // Enforce layout order: 2nd place → left, 1st place → center, 3rd → right
    const rankOrder = [2, 1, 3];

    return (
        <div className="leaderboard-container text-center p-4">
            {
                data.length > 0 ?
 <div className="row justify-content-center align-items-end" style={{ padding: '45px', gap: '20px', flexWrap: 'nowrap' }}>
                {rankOrder.map((rank, displayIndex) => {
                    const user = sorted[rank - 1];
                    if (!user) return null;

                    const isCenter = rank === 1;
                    const medal = medalMap[rank];
                    const frame = frameMap[rank];

                    return (
                        <div
                            key={user._id}
                            className={`col-12 col-sm-6 col-md-4 mb-4 ${isCenter ? 'order-2' : displayIndex === 0 ? 'order-1' : 'order-3'}`}
                        >
                            <div className={`card leaderboard-card ${isCenter ? 'first' : ''}`}>
                                <div className="medal-frame position-relative">
                                    <img src={frame} alt={`Rank ${rank}`} className="rank-frame-img" />
                                    <div className="profile-pic-img">
                                        {
                                           user.profileImageUrl ?

                                        <img
                                            // src={`https://api.dicebear.com/7.x/adventurer/svg?seed=${user.fullName}`}
                                            src={`${process.env.REACT_APP_BUCKET_URL}${user?.profileImageUrl}`}
                                            alt={user.fullName}
                                        />
                                            :
                            <div style={avatarFallbackStyle}>
                                {getInitials(user.fullName || "A")}
                            </div>
                                        }
                                       
                                    </div>
                                    <div className="medal-rank"
                                        style={{
                                            backgroundColor:
                                                rank === 1 ? 'gold' :
                                                    rank === 2 ? 'silver' :
                                                        rank === 3 ? '#cd7f32' : 
                                                            'white'
                                        }}
                                    >{rank}</div>
                                </div>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">{user.fullName}</h5>
                                    <p className="text-muted">{user.username}</p>
                                    <div className={`score-box ${medal}`}>
                                        {/* <img src={coinsIcon} alt={`icon`} style={{paddingRight:'10px'}} /> */}
                                        {/* <i className="bi bi-coin me-2"></i>  */}
                                        {user.combined} Pts
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
                :
   <div className="row justify-content-center align-items-end" style={{ padding: '45px', gap: '20px', flexWrap: 'nowrap', height: '400px' }}>
                     { [1, 2, 3].map((rank) => {
                         const isCenter = rank === 1;
                        const frame = frameMap[rank];

                        return (
                        <div
                            key={rank}
                            className={`col-12 col-sm-6 col-md-4 mb-4 ${isCenter ? 'order-2' : rank === 2 ? 'order-1' : 'order-3'
                                }`}
                        >
                            <div className={`card leaderboard-card placeholder-card ${isCenter ? 'first' : ''}`}>
                                <div className="medal-frame position-relative">
                                    <img src={frame} alt={`Rank ${rank}`} className="rank-frame-img" />
                                    <div className="profile-pic-img">
                                        {/* <img src="/placeholder-user.svg" alt="To be announced" /> */}
                                    </div>
                                    <div
                                        className="medal-rank"
                                        style={{
                                            backgroundColor:
                                                rank === 1 ? 'gold' : rank === 2 ? 'silver' : '#cd7f32',
                                        }}
                                    >
                                        {rank}
                                    </div>
                                </div>
                                <div className="card-body text-center">
                                    <h5 className="card-title mb-1">To be announced</h5>
                                </div>
                            </div>
                        </div>
                        );
    })}
                    </div>
            }
           
        </div>
    );
};

export default LeaderboardCard;
